import MultipleClientsFilter from './MultipleClientsFilter';

export default MultipleClientsFilter;


// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/multiple-clients-filter/index.js